export const sortByNumber = (array, key) => {
    const compareNumbers = (a, b) => {
        return a[key] - b[key];
    };
    return array.sort(compareNumbers);
};
export default sortByNumber;
//# sourceMappingURL=sortByNumber.js.map